<template>
    <div class="qinghai-page">
        <!-- 顶部页头 -->
        <Header></Header>

        <!-- 顶部 banner -->
        <div class="banner-box"></div>

        <!-- 主体内容 -->
        <div class="content-box">
            <div class="content-inner">
                <!-- 左侧课程分类 -->
                <div ref="asideMenu" :class="['aside-menu', asideFixed ? 'is-fixed' : '']">
                    <div class="menu-title"></div>
                    <div class="menu-panel">
                        <div
                            :class="['menu-item', menuActive == index ? 'active' : '']"
                            v-for="(item, index) in menuList"
                            :key="index"
                            @click="scrollToSection(item, index)"
                        >
                            <i :class="['icon', item.icon]"></i>
                            <span v-html="item.name"></span>
                        </div>
                    </div>
                </div>

                <!-- 右侧课程版块 -->
                <div class="sections-box" ref="sectionsBox">
                    <!-- 人文通识课 -->
                    <div class="course-section" id="section-rwtzk">
                        <div class="container">
                            <div class="section-title title-rwtzk"></div>

                            <!-- 二级分类 -->
                            <div class="cate-box" v-if="rwtzk.cateList.length">
                                <div
                                    :class="['cate-item', rwtzk.cateActive == index ? 'active' : '']"
                                    v-for="(cate, index) in rwtzk.cateList"
                                    :key="index"
                                    @click="changeCate(rwtzk, cate, index)"
                                >
                                    <i class="cate-dot"></i>
                                    <span>{{ cate.name }}</span>
                                </div>
                            </div>

                            <!-- 课程列表 -->
                            <template v-if="rwtzk.list && rwtzk.list.length">
                                <div class="course-list">
                                    <div class="course-item" v-for="(item, index) in rwtzk.list" :key="index" @click="jumpDetail(item)">
                                        <div class="img">
                                            <img :src="item.list_photo || item.photo" />
                                        </div>
                                        <div class="txt">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-hide"></div>
                                    <div class="flex-hide"></div>
                                </div>
                                <a-pagination
                                    v-if="rwtzk.total > rwtzk.size"
                                    :current="rwtzk.page"
                                    :pageSize="rwtzk.size"
                                    :total="rwtzk.total"
                                    @change="(page) => onPageChange(rwtzk, page)"
                                />
                            </template>
                            <div class="empty-box" v-else>课程建设中</div>
                        </div>
                    </div>

                    <!-- 趣味科普课 -->
                    <div class="course-section" id="section-qwkpk">
                        <div class="container">
                            <div class="section-title title-qwkpk"></div>

                            <!-- 二级分类 -->
                            <div class="cate-box" v-if="qwkpk.cateList.length">
                                <div
                                    :class="['cate-item', qwkpk.cateActive == index ? 'active' : '']"
                                    v-for="(cate, index) in qwkpk.cateList"
                                    :key="index"
                                    @click="changeCate(qwkpk, cate, index)"
                                >
                                    <i class="cate-dot"></i>
                                    <span>{{ cate.name }}</span>
                                </div>
                            </div>

                            <!-- 课程列表 -->
                            <template v-if="qwkpk.list && qwkpk.list.length">
                                <div class="course-list">
                                    <div class="course-item" v-for="(item, index) in qwkpk.list" :key="index" @click="jumpDetail(item)">
                                        <div class="img">
                                            <img :src="item.list_photo || item.photo" />
                                        </div>
                                        <div class="txt">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-hide"></div>
                                    <div class="flex-hide"></div>
                                </div>
                                <a-pagination
                                    v-if="qwkpk.total > qwkpk.size"
                                    :current="qwkpk.page"
                                    :pageSize="qwkpk.size"
                                    :total="qwkpk.total"
                                    @change="(page) => onPageChange(qwkpk, page)"
                                />
                            </template>
                            <div class="empty-box" v-else>课程建设中</div>
                        </div>
                    </div>

                    <!-- 科学实验课 -->
                    <div class="course-section" id="section-kxsyk">
                        <div class="container">
                            <div class="section-title title-kxsyk"></div>

                            <!-- 二级分类 -->
                            <div class="cate-box" v-if="kxsyk.cateList.length">
                                <div
                                    :class="['cate-item', kxsyk.cateActive == index ? 'active' : '']"
                                    v-for="(cate, index) in kxsyk.cateList"
                                    :key="index"
                                    @click="changeCate(kxsyk, cate, index)"
                                >
                                    <i class="cate-dot"></i>
                                    <span>{{ cate.name }}</span>
                                </div>
                            </div>

                            <!-- 课程列表 -->
                            <template v-if="kxsyk.list && kxsyk.list.length">
                                <div class="course-list">
                                    <div class="course-item" v-for="(item, index) in kxsyk.list" :key="index" @click="jumpDetail(item)">
                                        <div class="img">
                                            <img :src="item.list_photo || item.photo" />
                                        </div>
                                        <div class="txt">
                                            <div class="name">{{ item.name }}</div>
                                        </div>
                                    </div>
                                    <div class="flex-hide"></div>
                                    <div class="flex-hide"></div>
                                </div>
                                <a-pagination
                                    v-if="kxsyk.total > kxsyk.size"
                                    :current="kxsyk.page"
                                    :pageSize="kxsyk.size"
                                    :total="kxsyk.total"
                                    @change="(page) => onPageChange(kxsyk, page)"
                                />
                            </template>
                            <div class="empty-box" v-else>课程建设中</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 页脚 -->
        <div class="footer-box">
            <div class="footer-inner">
                <img class="footer-logo" src="../../../assets/custom/qinghai/logo.png" />
                <div class="footer-info">
                    <div>北京中教互联教育科技有限公司</div>
                    <div>北京市海淀区文慧园北路9号今典花园9号楼-教育在线</div>
                </div>
                <div class="footer-contact">
                    <div class="label">业务合作：</div>
                    <div class="phone">冯老师13501261900</div>
                </div>
            </div>
            <div class="footer-copyright">
                <span>版权所有 北京中教互联教育科技有限公司</span>
                <a href="http://www.eol.cn/html/cer.net/icp.htm" target="_blank">京ICP证140769号</a>
                <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">京ICP备2022007846号-1</a>
                <a href="http://img.eol.cn/images/indexnew/www1024.jpg" target="_blank">京网文[2014]2106-306号</a>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020236" target="_blank">京公网安备 11010802020236号</a>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import utils from '../../../config/utils';
    import services from '../../../config/services';
    import Header from '../../../components/Header.vue';
    export default {
        name: 'Qinghai',
        data() {
            return {
                school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem('schoolCode'),
                menuActive: 0,
                asideFixed: false, // 左侧菜单是否吸顶
                // 左侧课程分类菜单，target 对应右侧课程版块
                menuList: [
                    { name: '人文<br>通识课', icon: 'icon-rwkc', target: 'rwtzk' },
                    { name: '趣味<br>科普课', icon: 'icon-xbkc', target: 'qwkpk' },
                    { name: '科学<br>实验课', icon: 'icon-kfkc', target: 'kxsyk' },
                ],
                // 课程版块：rootId 为一级分类 id（固定：497 人文通识课 / 498 趣味科普课 / 499 科学实验课）
                // 人文通识课
                rwtzk: {
                    key: 'rwtzk',
                    rootId: '497',
                    className: '人文通识课',
                    cateList: [],
                    cateActive: 0,
                    categoryId: '',
                    list: [],
                    page: 1,
                    size: 8,
                    total: 0,
                },
                // 趣味科普课
                qwkpk: {
                    key: 'qwkpk',
                    rootId: '498',
                    className: '趣味科普课',
                    cateList: [],
                    cateActive: 0,
                    categoryId: '',
                    list: [],
                    page: 1,
                    size: 8,
                    total: 0,
                },
                // 科学实验课
                kxsyk: {
                    key: 'kxsyk',
                    rootId: '499',
                    className: '科学实验课',
                    cateList: [],
                    cateActive: 0,
                    categoryId: '',
                    list: [],
                    page: 1,
                    size: 8,
                    total: 0,
                },
                menuOpen: false,
                services,
            };
        },
        components: { Header },
        computed: {
            ...mapState({
                loginUserInfo: (state) => state.appsLogin.appsUserInfo,
                schoolInfo: (state) => state.appsLogin.schoolInfo,
            }),
            // 版块顺序（自上而下），供初始化加载和滚动高亮使用
            sections() {
                return [this.rwtzk, this.qwkpk, this.kxsyk];
            },
        },
        async mounted() {
            // 如果不是青海k12code,返回到404
            // if (this.school_code != utils.qhk12_code) {
            //     return this.$router.push(`/${this.school_code}/404`);
            // }
            await this.getAppsLoginUserInfo();
            await this.getLoginSchoolInfo({ school_code: this.school_code }).then((res) => {
                if (res.code == '0000') utils.setTitle(document.title + '-' + res.data.school_name);
            });
            this.sections.forEach(async (section) => {
                await this.getCategory(section); // 内部会默认选中第一个分类并拉取课程列表
            });
            window.addEventListener('scroll', this.handleScroll, true);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            ...mapActions(['getAppsLoginUserInfo', 'getLoginSchoolInfo', 'requestAppsLogout']),

            // 获取二级分类（root_id 固定：497 人文通识课 / 498 趣味科普课 / 499 科学实验课）
            getCategory(section) {
                if (!section.rootId) return;
                services
                    .getCourseCategory({ root_id: section.rootId })
                    .then((res) => {
                        if (res.code == '0000' && res.data && res.data.length) {
                            section.cateList = res.data;
                            // 默认选中第一个分类，用它拉取课程列表
                            section.cateActive = 0;
                            section.categoryId = res.data[0].id;
                        } else {
                            // 没有二级分类时，直接用父分类请求课程
                            section.categoryId = section.rootId;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.getCourseList(section);
                    });
            },

            // 切换二级分类
            changeCate(section, cate, index) {
                section.cateActive = index;
                section.categoryId = cate.id;
                section.page = 1;
                this.getCourseList(section);
            },

            // 获取课程列表
            getCourseList(section) {
                services
                    .getCourseLists({
                        category_id: section.categoryId,
                        page: section.page,
                        size: section.size,
                    })
                    .then((res) => {
                        if (res.code == '0000' && res.data && res.data.items && res.data.items.length) {
                            section.list = res.data.items;
                            section.total = res.data.total || res.data.items.length;
                        } else {
                            section.list = [];
                            section.total = 0;
                        }
                    })
                    .catch(() => {});
            },

            // 翻页
            onPageChange(section, page) {
                section.page = page;
                this.getCourseList(section);
            },

            // 页头-课程资源，滚动到课程版块区域
            scrollToResource() {
                let el = this.$refs.sectionsBox;
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            },

            // 页头-学习中心
            jumpCenter() {
                window.open(`/center/${this.school_code}/user/myClass`, '_blank');
            },

            // 页头-登录
            handleLogin() {
                window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, '_self');
            },

            // 退出登录
            logoutEvents() {
                if (window.location.href.indexOf('hzvtc/detail') > -1) {
                    localStorage.setItem('eol-hzvtc-detail-key', this.$route.query.key);
                }
                this.requestAppsLogout();
            },

            // 菜单点击，滚动到对应版块
            scrollToSection(item, index) {
                this.menuActive = index;
                let el = document.getElementById(`section-${item.target}`);
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            },

            // 滚动监听：左侧菜单吸顶 + 高亮当前版块对应的菜单
            handleScroll() {
                this.$nextTick(() => {
                    // 吸顶判断：滚动超过菜单自然顶部位置时吸顶，回滚到原位时取消吸顶
                    let aside = this.$refs.asideMenu;
                    if (aside) {
                        let inner = aside.parentElement; // .content-inner（fixed 后 offsetParent 会变，故用 parentElement）
                        let innerTop = inner.getBoundingClientRect().top + window.scrollY;
                        let threshold = innerTop + 78; // aside-menu 的自然顶部位置（top: 78px）
                        let isFixed = window.scrollY >= threshold;
                        if (isFixed !== this.asideFixed) {
                            this.asideFixed = isFixed;
                        }
                    }

                    // 按页面版块顺序（自上而下）找到最后一个进入阈值的版块
                    let activeTarget = this.sections[0].key;
                    this.sections.forEach((section) => {
                        let el = document.getElementById(`section-${section.key}`);
                        if (el && el.getBoundingClientRect().top <= 200) {
                            activeTarget = section.key;
                        }
                    });
                    // 滚动到页面底部时，高亮最后一个版块
                    if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 2) {
                        activeTarget = this.sections[this.sections.length - 1].key;
                    }
                    let index = this.menuList.findIndex((item) => item.target == activeTarget);
                    if (index > -1) this.menuActive = index;
                });
            },

            // 跳转课程详情
            jumpDetail(item) {
                // if (!this.loginUserInfo) {
                //     return this.handleLogin();
                // }
                window.open(`/center/${this.school_code}/nologin/class/${item.id}`, '_blank');
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        z-index: 2;
    }
    .qinghai-page {
        width: 100%;
        min-height: 100vh;
        background: #ffffff;
    }

    // 顶部页头
    .eol-header-box {
        width: 100%;
        height: 70px;
        background: #ffffff;

        .header-inner {
            // width: 1200px;
            padding: 0 0 0 20px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .logo {
                width: auto;
                height: auto;
                max-height: 34px;
                max-width: 300px;
            }

            .nav-box {
                display: flex;
                align-items: center;

                .nav-item {
                    font-weight: bold;
                    font-size: 17px;
                    color: #333333;
                    cursor: pointer;

                    &:not(:last-child) {
                        margin-right: 85px;
                    }

                    &.active,
                    &:hover {
                        color: #38a2cf;
                    }
                }
            }
        }
    }

    // 顶部 banner
    .banner-box {
        width: 100%;
        height: 500px;
        background: url('../../../assets/custom/qinghai/banner.jpg') no-repeat center/cover;
    }

    // 主体内容
    .content-box {
        width: 100%;

        .content-inner {
            display: flex;
            align-items: flex-start;
            position: relative;
        }
    }

    // 左侧课程分类
    .aside-menu {
        flex-shrink: 0;
        width: 132px;
        margin-top: 40px;
        position: absolute;
        right: 120px;
        top: 78px;
        z-index: 10;

        // 吸顶状态：滚动到菜单顶部时固定在视口顶部
        &.is-fixed {
            position: fixed;
            top: 0;
        }
        .menu-title {
            height: 72px;
            background: url('../../../assets/custom/qinghai/bar-title.png') no-repeat center/contain;
        }

        .menu-panel {
            padding: 24px 16px;
            background: #38a2cf;
            border-radius: 0px 0px 6px 6px;
        }

        .menu-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            // height: 80px;
            background: #1e8ebd;
            border-radius: 4px;
            cursor: pointer;
            padding: 15px 0;
            text-align: center;
            &:not(:last-child) {
                margin-bottom: 9px;
            }

            .icon {
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                &.icon-kfkc {
                    width: 22px;
                    height: 20px;
                    background-image: url('../../../assets/custom/qinghai/bar-kfkc.png');
                }

                &.icon-rwkc {
                    width: 22px;
                    height: 19px;
                    background-image: url('../../../assets/custom/qinghai/bar-rwkc.png');
                }

                &.icon-xbkc {
                    width: 22px;
                    height: 19px;
                    background-image: url('../../../assets/custom/qinghai/bar-xbkc.png');
                }
            }

            span {
                margin-top: 5px;
                font-weight: bold;
                font-size: 14px;
                color: #f4f7f8;
                ::v-deep br {
                    display: none;
                }
            }

            &:hover,
            &.active {
                background: #f4f7f8;
                span {
                    color: #1698cc;
                }
            }
        }
    }

    // 右侧课程版块
    .sections-box {
        width: 100%;
    }

    .course-section {
        padding: 48px 0 46px;
        &#section-rwtzk {
            background: #f4f7f8;
        }

        &#section-qwkpk {
            position: relative;
            padding: 47px 0 102px;
            // min-height: 700px;
            overflow: hidden;

            &::before {
                content: '';
                display: inline-block;
                width: 100%;
                height: 562px;
                background: url('../../../assets/custom/qinghai/qwkpk-bg.png') no-repeat center/cover;
                position: absolute;
                bottom: 66px;
                left: 0;
                z-index: 1;
            }
        }

        &#section-kxsyk {
            background: linear-gradient(to bottom, #fffef4 0%, #fffef4 100%);
        }

        .section-title {
            width: 488px;
            height: 63px;
            margin: 0 auto 32px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            &.title-qwkpk {
                background-image: url('../../../assets/custom/qinghai/title-qwkpk.png');
            }

            &.title-kxsyk {
                background-image: url('../../../assets/custom/qinghai/title-kxsyk.png');
            }

            &.title-rwtzk {
                background-image: url('../../../assets/custom/qinghai/title-rwtzk.png');
            }
        }

        // 二级分类
        .cate-box {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 24px;

            .cate-item {
                display: flex;
                align-items: center;
                padding: 7.5px 33px;
                margin: 0 24px 14px 0;
                border-radius: 24px;
                background: #ffffff;
                cursor: pointer;
                position: relative;
                .cate-dot {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -7px;
                    background: url('../../../assets/custom/qinghai/menu.png') no-repeat center/cover;
                }

                span {
                    font-weight: bold;
                    font-size: 17px;
                    color: #333333;
                }

                &.active,
                &:hover {
                    background: #38a2cf;

                    .cate-dot {
                        background: url('../../../assets/custom/qinghai/menu-active.png') no-repeat center/cover;
                        width: 21px;
                        height: 21px;
                        left: -11px;
                    }
                    span {
                        color: #ffffff;
                    }
                }
            }
        }

        // 课程列表
        .course-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .flex-hide {
                flex: 0 0 285px;
                display: inline-block;
                overflow: visible;
                visibility: hidden;
                height: 0;
            }
        }

        .course-item {
            flex: 0 0 285px;
            background: #ffffff;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 20px;
            padding: 4px 4px 0;
            &:hover {
                background: #38a2cf;
                .txt {
                    background: #38a2cf;

                    .name {
                        color: #ffffff;
                    }
                }
                .img img {
                    transform: scale(1.1);
                }
            }

            .img {
                width: 100%;
                height: auto;
                aspect-ratio: 16/9;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }
            }

            .txt {
                padding: 18px 16px 16px;
                height: 60px;
                background: #ffffff;
                display: flex;
                align-items: center;
                .name {
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        // 分页
        ::v-deep .ant-pagination {
            text-align: center;
            margin: 6px 0 0;

            .ant-pagination-item {
                border-radius: 2px;
                border: 1px solid #b1c9d3;
                background: #f4f7f8;

                a {
                    font-size: 14px;
                    color: #658491;
                }

                &:hover {
                    border-color: #2b9fe0;

                    a {
                        color: #2b9fe0;
                    }
                }

                &.ant-pagination-item-active {
                    background: #1698cc;
                    border: 1px solid #1698cc;

                    a {
                        color: #ffffff;
                    }
                }
            }
            .ant-pagination-prev {
                margin-right: 68px;
                .ant-pagination-item-link::before {
                    background-image: url('../../../assets/custom/qinghai/page-prev.png');
                    right: -9px;
                }
            }
            .ant-pagination-next {
                margin-left: 68px;
                .ant-pagination-item-link::before {
                    background-image: url('../../../assets/custom/qinghai/page-next.png');
                    left: -9px;
                }
            }
            .ant-pagination-prev,
            .ant-pagination-next {
                .ant-pagination-item-link {
                    border: 0;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background: linear-gradient(to right, #c0ecff 0%, #f4f7f8 100%);
                    position: relative;
                    .anticon {
                        display: none;
                    }
                    &::before {
                        content: '';
                        display: inline-block;
                        width: 28px;
                        height: 10px;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }

                &:not(.ant-pagination-disabled):hover .ant-pagination-item-link {
                    border-color: #2b9fe0;
                }
            }
            .ant-pagination-next {
                .ant-pagination-item-link {
                    background: linear-gradient(to left, #c0ecff 0%, #f4f7f8 100%);
                }
            }
        }

        // 空数据
        .empty-box {
            padding: 64px 0;
            text-align: center;
            font-size: 15px;
            color: #9aa5b5;
            border-radius: 10px;
        }
    }

    .eol-header-box .eol-right-user {
        display: inline-block;
        vertical-align: top;
        margin-right: 30px;
        max-width: 260px;
        position: relative;
    }

    .eol-header-box .eol-right-user .close-page-box {
        position: absolute;
        display: inline-block;
        font-size: 16px;
        color: #3a3a3a;
        display: inline-block;
        margin-left: 5px;
        top: 13px;
        left: -80px;
        cursor: pointer;
    }

    .eol-header-box .eol-right-user .close-page-box img {
        vertical-align: -4px;
    }

    .eol-header-box .eol-right-user .mine-lines {
        height: 70px;
        line-height: 70px;
        font-size: 14px;
        font-weight: 400;
        color: #125cfb;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .eol-header-box .eol-right-user .mine-lines span {
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 200px;
        margin: 0 16px 0 6px;
    }

    .eol-header-box .eol-right-user .mine-lines::after {
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background-image: url('../../../assets/site/header/icons-jiantou-down.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        margin-left: 4px;
    }

    .eol-header-box .eol-right-user.up .mine-lines::after {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
    }

    .eol-header-box .eol-right-user.down .mine-lines::after {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
    }

    .eol-header-box .eol-right-user .user-imgs-box {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: middle;
        text-align: right;
        background: url('../../../assets/site/header/mine-icons.png') no-repeat center;
        background-size: 100% auto;
    }

    .eol-header-box .eol-right-user .eol-submine-box {
        background: #ffffff;
        border: 1px solid #dfe3e4;
        position: absolute;
        z-index: 1000;
        top: 70px;
        right: -10px;
        padding: 18px 15px 18px 20px;
        text-align: left;
        display: none;
        min-width: 130px;
    }

    .eol-header-box .eol-right-user.up .eol-submine-box {
        display: block;
    }

    .eol-header-box .eol-right-user.down .eol-submine-box {
        display: none;
    }

    .eol-header-box .eol-right-user .submine-items {
        height: 30px;
        color: #71737b;
        line-height: 30px;
        font-size: 14px;
        cursor: pointer;
    }
    .eol-header-box .eol-right-user .submine-items a {
        display: block;
        width: auto;
        color: #71737b;
    }

    .eol-header-box .eol-right-user .submine-items.active,
    .eol-header-box .eol-right-user .submine-items:hover a {
        color: #3460e4;
        text-decoration: none;
    }

    .eol-header-box .eol-right-user .mine-left-icons {
        width: 14px;
        height: 14px;
        margin-right: 6px;
        display: inline-block;
        vertical-align: -2px;
    }
    /* header ---- 结束 */

    // 页脚
    .footer-box {
        width: 100%;
        background: #f2f3f5;

        .footer-inner {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 28px 0 24px;

            .footer-logo {
                width: 342px;
                height: auto;
            }

            .footer-info {
                font-size: 14px;
                color: #696969;
                line-height: 22px;
                div:first-child {
                    font-size: 16px;
                    color: #333333;
                    line-height: 22px;
                    margin-bottom: 10px;
                }
            }

            .footer-contact {
                font-size: 14px;
                color: #696969;
                position: relative;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 43px;
                    height: 34px;
                    position: absolute;
                    right: -4px;
                    top: -8px;
                    background: url('../../../assets/custom/qinghai/contact.png') no-repeat center/cover;
                }

                .label {
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                    margin-bottom: 10px;
                }
            }
        }

        .footer-copyright {
            width: 100%;
            background: #e0e3e8;
            height: 40px;
            line-height: 40px;
            text-align: center;

            span,
            a {
                display: inline-block;
                vertical-align: top;
                margin: 0 8px;

                font-size: 12px;
                color: #696969;
            }

            a:hover {
                color: #38a2cf;
            }
        }
    }

    @media screen and (max-width: 1900px) {
        .aside-menu {
            right: 40px;
        }
    }

    @media screen and (max-width: 1600px) {
        .aside-menu {
            right: 0px;
        }
    }

    @media screen and (max-width: 1550px) {
        .aside-menu {
            width: 65px;
            .menu-title {
                height: 36px;
            }
            .menu-panel {
                padding: 10px 7px;
                .menu-item {
                    span {
                        font-size: 12px;
                        ::v-deep br {
                            display: block;
                        }
                    }
                }
            }
        }
    }
</style>
